<template>
    <div class="invoiceSuccess flex-column align-center">
        <img class="invoiceSuccess-img" src="@/assets/images/invocie/invocie-succeess.png" alt="" />
        <template v-if="!success">
            <van-loading color="#1989fa" style="margin: 30px" />
            <p class="invoiceSuccess-text">提交成功，等待开票</p>
        </template>

        <template v-if="success">
            <div class="loading"></div>
            <p class="invoiceSuccess-text">开票成功</p>
        </template>

        <van-button color="#009AF3 " class="comfirm-btn" @click="$router.push('/invoice/record')">开票历史</van-button>
        <p class="invoiceSuccess-service-phone">服务热线：{{ zzconfig.PHONE }}</p>
    </div>
</template>

<script>
import { resultInvoice } from "@/api/index";
import { zzconfig } from "@/config/zzconfig";

export default {
    name: "InvoiceSuccess",
    data() {
        return {
            zzconfig,
            success: false, //开票是否成功
        };
    },
    mounted() {
        let that = this;
        setTimeout(function () {
            resultInvoice(that.$route.params).then((res) => {
                if (res.data.length == 1 || res.data[0].status != 2) {
                    that.success = true;
                } else if (res.data.length == 2) {
                    let flag = res.data.every((item) => item.status != 2);
                    if (!flag) {
                        that.$toast("部分发票开票失败");
                    } else {
                        that.success = true;
                    }
                }
                for (let i of res.data) {
                }
            });
        }, 5000);
    },
};
</script>

<style lang="less" scoped>
.loading {
    margin: 60px;
    width: 60px;
    height: 60px;
}
.invoiceSuccess {
    min-height: 100vh;
    padding: 30px;
    .invoiceSuccess-img {
        width: 280px;
        height: 254px;
        margin-top: 62px;
    }
    .invoiceSuccess-text {
        font-size: 30px;
        color: #333333;
        margin: 20px 0 96px;
    }
    .invoiceSuccess-service-phone {
        font-size: 30px;
        color: #33333380;
        margin-top: auto;
    }
}
</style>
